import { CONSENT_STATUS_ENUM } from '@app/open-insurance/modules/consents/services/opin-consent/opin-consent.model';

export const SharingStatus = {
  [CONSENT_STATUS_ENUM.AUTHORISED]: 'Ativo até ',
  [CONSENT_STATUS_ENUM.EXPIRED]: 'Vencido em ',
  [CONSENT_STATUS_ENUM.CLOSED]: 'Encerrado em ',
  [CONSENT_STATUS_ENUM.REJECTED]: 'Rejeitado em ',
  [CONSENT_STATUS_ENUM.AWAITING_AUTHORISATION]: 'Esperando autorização desde ',
  [CONSENT_STATUS_ENUM.REVOKED]: 'Revogado em '
};
